import React from 'react';
import useScreenBreakpoint from '../../hooks/useMediaQuery';

const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

enum ScreenWidth {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

interface Props {
  children?: any;
  lgDown?: boolean;
  lgUp?: boolean;
  mdDown?: boolean;
  mdUp?: boolean;
  only?: ScreenWidth | ScreenWidth[];
  smDown?: boolean;
  smUp?: boolean;
  xlDown?: boolean;
  xlUp?: boolean;
  xsDown?: boolean;
  xsUp?: boolean;
}

const Hidden: React.FC<Props> = (props) => {
  const screenBreakPoint = useScreenBreakpoint();
  const { children, only } = props;
  let visible = true;

  if (only) {
    if (Array.isArray(only)) {
      for (let i = 0; i < only.length; i += 1) {
        const breakpoint = only[i];
        if (screenBreakPoint === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && screenBreakPoint === only) {
      visible = false;
    }
  }

  if (visible) {
    const breakpointKeys = Object.keys(breakpoints);

    for (let i = 0; i < breakpointKeys.length; i += 1) {
      const breakpoint = breakpointKeys[i];
      const breakpointUp: boolean = props[`${breakpoint}Up`];
      const breakpointDown: boolean = props[`${breakpoint}Down`];
      if (
        (breakpointUp && isWidthUp(breakpoint, screenBreakPoint)) ||
        (breakpointDown && isWidthDown(breakpoint, screenBreakPoint))
      ) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
};

const isWidthUp = (breakpoint: string, width: string, inclusive = true) => {
  if (inclusive) {
    return Object.keys(breakpoints).indexOf(breakpoint) <= Object.keys(breakpoints).indexOf(width);
  }
  return Object.keys(breakpoints).indexOf(breakpoint) < Object.keys(breakpoints).indexOf(width);
};

const isWidthDown = (breakpoint, width: string, inclusive = false) => {
  if (inclusive) {
    return Object.keys(breakpoints).indexOf(width) <= Object.keys(breakpoints).indexOf(breakpoint);
  }
  return Object.keys(breakpoints).indexOf(width) < Object.keys(breakpoints).indexOf(breakpoint);
};

export default Hidden;
